<template>
	<div>
		<h1>Data Extraction</h1>

		<InputSelectDropdown
			question="How many studies was the data extraction form piloted on? (for study characteristics and outcome data)"
			v-model="$tera.project.numberOfStudies"
			:options="numberOptions"
		/>

		<!-- <InputTextNumber
			question="How many study authors extracted the following data from included studies?"
			v-model="numberOfExtractors"
		/> -->

		<!--<InputSelectDropdown
			question="How many study authors extracted the following data from included studies?"
			:value="extraction.numberOfExtractors"
			@input="updateField('numberOfExtractors', $event)"
			:options="extractorsOption"
		/>-->

		<InputSelectMultiWithoutOthers
			question="Which author/s performed data extraction?"
			v-model="$tera.project.extractionAuthors"
			:options="
				/*titlepage.authors.map(el => {
					return { label: el };
				})*/
				this.pfDataExtractAuthors
			"
		/>
		<InputTextNumber
			question="The number of study authors who extracted the following data from included studies was"
			v-model="numberOfExtractors"
			:disabled="disabled"
		/>
		<InputSelectYesNo
			question="Do you wish to specify what data will be extracted (optional)"
			v-model="$tera.project.optionalDetail"
		/>

		<!-- New -->
		<Accordion
			v-if="$tera.project.optionalDetail" :activeIndex="0"
			style="margin-top: 50px; border: 1px solid black;"
		>
			<AccordionTab header="Optional Details" :active="0">
				<h3>What data will be extracted:</h3>
				<InputSelectMultiDeAggrid
					question="Methods:"
					:options="options.methods"
					v-model="$tera.project.methods"
				/>
				<InputSelectMultiDeAggrid
					question="Participants:"
					:options="options.participants"
					v-model="$tera.project.participants"
				/>
				<InputSelectMultiDeAggrid
					question="Interventions:"
					:options="options.interventions"
					v-model="$tera.project.interventions"
				/>
				<InputSelectMultiDeAggrid
					question="Comparators:"
					:options="options.comparators"
					v-model="$tera.project.comparators"
				/>
				<InputTable
					question="Outcomes:"
					v-model="$tera.project.extractionOutcomes"
					columnHeader="Outcome"
					:isSelectButton="false"
					:inclusion="true"
					:type="true"
					:description="true"
					:examples="true"
					mainPlaceholder="e.g. investigator-assessed change in acne severity"
				/>
				<Message
					v-if="
						!arrayEquals($tera.project.outcomes, $tera.project.extractionOutcomes)
					"
					severity="warn"
					:closable="false"
				>
					<div class="message-inside-text">
						Not the same as PICOST outcomes
					</div>
					<!--@click="updateField('outcomes', picot.outcomes)"-->
					<Button
						label="Copy from PICOST section"
						class="p-button-sm btsyleblue"
						@click="$tera.project.extractionOutcomes = $tera.project.outcomes"
					/>
				</Message>
				<InputSelectMulti
					question="Types:"
					:options="options.types"
					v-model="$tera.project.extractionTypes"
				/>
				<Message
					v-if="!arrayEquals($tera.project.types, $tera.project.extractionTypes)"
					severity="warn"
					:closable="false"
				>
					<div class="message-inside-text">
						Not the same as PICOST types
					</div>
					<!--@click="updateField('types', picot.types)"-->
					<Button
						label="Copy from PICOST section"
						class="p-button-sm btsyleblue"
						@click="$tera.project.extractionTypes = $tera.project.types"
					/>
				</Message>
			</AccordionTab>
		</Accordion>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";

import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Message from "primevue/message";
import Button from "primevue/button";

import BasePreviewOutput from "@/components/BasePreviewOutput.vue";
import OutputDataExtraction from "./OutputDataExtraction.vue";
import InputSelectDropdown from "@/components/InputSelectDropdown.vue";
import InputSelectMulti from "@/components/InputSelectMulti.vue";
import InputSelectMultiDeAggrid from "../../components/InputSelectMultiDeAggrid.vue";
import InputSelectMultiWithoutOthers from "@/components/InputSelectMultiWithoutOther.vue";
import InputTable from "@/components/InputTable.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";

export default {
	name: "ViewMethodDataExtraction",
	components: {
		Accordion,
		AccordionTab,
		Message,
		Button,
		InputSelectDropdown,
		InputSelectMulti,
		InputSelectMultiWithoutOthers,
		InputTable,
		BasePreviewOutput,
		InputSelectYesNo,
		InputSelectMultiDeAggrid
	},
	computed: {
		numberOfExtractors() {
			return this.$tera.project.extractionAuthors?.length;
		},
		pfDataExtractAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.academyWizard.planTable?.rows.forEach(el => {
				if (el.tasks == "Extract data" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		}
	},
	methods: {
		checkUnion(U) {
			for (var i = 0; i < U.length; i++) {
				for (var j = i + 1; j < U.length; j++) {
					if (U[i].label == U[j].label) {
						U.splice(j, 1);
						j--;
					}
				}
			}
		},
		compareLabel(a, b) {
			if (a.label < b.label) {
				return -1;
			} else if (a.label > b.label) {
				return 1;
			} else {
				return 0;
			}
		},
		compareMain(a, b) {
			if (a.main < b.main) {
				return -1;
			} else if (a.main > b.main) {
				return 1;
			} else {
				return 0;
			}
		},
		arrayEquals(arr1, arr2) {
			let sorted1;
			let sorted2;
			if (arr1 && arr2) {
				if (arr1[0]?.label && arr2[0]?.label) {
					sorted1 = sortBy(arr1, "label");
					sorted2 = sortBy(arr2, "label");
				} else if (arr1[0]?.main && arr2[0]?.main) {
					sorted1 = sortBy(arr1, "main");
					sorted2 = sortBy(arr2, "main");
				} else {
					sorted1 = arr1;
					sorted2 = arr2;
				}
			} else {
				return false;
			}
			return isEqual(sorted1, sorted2);
		}
	},
	mounted() {
		//extraction Outcomes & Types
		if (
			!this.$tera.project.extractionOutcomes ||
			JSON.stringify(this.$tera.project.extractionOutcomes) ==
				'[{"inclusion":true,"type":true}]'
		) {
			// console.log("this.extraction.types",...this.picot.types);
			if (this.$tera.project.outcomes) {
				// console.log("this.picot.outcomes", this.picot.outcomes, this.extraction.outcomes)
				// Deep copy
				this.$tera.project.extractionOutcomes = JSON.parse(
					JSON.stringify(this.$tera.project.outcomes)
				);
			}
		}

		if (
			this.$tera.project.extractionTypes &&
			this.$tera.project.extractionTypes.length === 0
		) {
			// Shallow copy : extraction types= picot types
			this.$tera.project.extractionTypes = [...this.$tera.project.types];
		}
	},
	data() {
		return {
			//pfDataExtractAuthors: [], //--perform data extraction authors
			numberOptions: ["1", "2", "3", "4", "5", "6"],
			outputComponent: OutputDataExtraction,
			options: {
				methods: [
                    { label: "Study authors", field:'studyAuthors', headerName: "Study authors" },
                    { label: "Year", field:'year', headerName: "Year" },
                    { label: "Country", field:'country', headerName: "Country" },
                    { label: "Study design", field:'studyDesign', headerName: "Study design" },
                    { label: "Duration of follow-up", field:'durationOfFollowUp', headerName: "Duration of follow-up" },
                    { label: "Setting", field:'setting', headerName: "Setting" }
                ],
				participants: [
					{ label: "Number of participants", field:'numberOfParticipants', headerName: "Number of participants" },
					{ label: "Age", field:'age', headerName: "Age" },
					{ label: "Gender", field:'gender', headerName: "Gender" },
					{ label: "Whether currently pregnant", field:'whetherCurrentlyPregnant', headerName: "Whether currently pregnant" },
					{ label: "Smoker", field:'smoker', headerName: "Smoker" },
					{ label: "Any co-comorbidity", field:'anyCoComorbidity', headerName: "Any co-comorbidity" },
					{ label: "Education level", field:'educationLevel', headerName: "Education level" }
				],
				interventions: [
					{ label: "Type of intervention", field:'typeOfIntervention', headerName: "Type of intervention" },
					{ label: "Dose(I)", field:'doseI', headerName: "Dose(I)" },
					{ label: "Frequency(I)", field:'frequencyI', headerName: "Frequency(I)" },
					{ label: "Method of delivery(I)", field:'methodOfDeliveryI', headerName: "Method of delivery(I)" },
					{ label: "Who provided the intervention(I)", field:'whoProvidedTheInterventionI', headerName: "Who provided the intervention(I)" },
					{ label: "How the intervention was provided(I)", field:'howTheInterventionWasProvidedI', headerName: "How the intervention was provided(I)" }
				],
				comparators: [
					{ label: "Placebo", field:'placebo', headerName: "Placebo" },
					{ label: "Usual care", field:'usualCare', headerName: "Usual care" },
					{ label: "Sham device", field:'shamDevice', headerName: "Sham device" },
					{ label: "No treatment", field:'noTreatment', headerName: "No treatment" },
					{ label: "Dose", field:'dose', headerName: "Dose" },
					{ label: "Frequency", field:'frequency', headerName: "Frequency" },
					{ label: "Method of delivery", field:'methodOfDelivery', headerName: "Method of delivery" },
					{ label: "Who provided the intervention", field:'whoProvidedTheIntervention', headerName: "Who provided the intervention" },
					{ label: "How the intervention was provided", field:'howTheInterventionWasProvided', headerName: "How the intervention was provided" }
				],
				types: [
					{ label: "Systematic Reviews", field:'systematicReviews', headerName: "Systematic Reviews" },
					{ label: "Observational Studies", field:'observationalStudies', headerName: "Observational Studies" },
					{ label: "Randomized Controlled Trials", field:'randomizedControlledTrials', headerName: "Randomized Controlled Trials" },
					{ label: "Cohort Studies", field:'cohortStudies', headerName: "Cohort Studies" },
					{ label: "Longitudinal studies", field:'longitudinalStudies', headerName: "Longitudinal studies" },
					{ label: "Before after studies", field:'beforeAfterStudies', headerName: "Before after studies" },
					{ label: "Surveys", field:'surveys', headerName: "Surveys" },
					{ label: "Letters", field:'letters', headerName: "Letters" },
					{ label: "Editorials", field:'editorials', headerName: "Editorials" }
				]
			},
			disabled:true
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.p-message-text {
	display: inline-flex;
	width: 100%;
}

.message-inside-text {
	/* Align text horizontal center with right float button */
	margin: auto auto auto 0px;
}

.btsyleblue {
	margin: 10px;
	/* width: 100px; */
	background-color: #83bfed;
	border-radius: 20px;
	/* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px; */
	color: #05305f;
	cursor: pointer;
	display: inline-block;
	font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
	padding: 7px 20px;
	text-align: center;
	text-decoration: none;
	/* transition: all 250ms; */
	border: 0;
	font-size: 16px;
}
</style>
